import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import { useEffect, PropsWithChildren, useState } from 'react'

import { facadeApi } from 'api'
import { loginRequest } from 'auth/config'

const apiInstances = [facadeApi]

/*== Open Projects and colliderTCCC APIs will be considered for future integration ==*/

// token source changed from wppToken to msalToken
// const getInterceptorToEjectColliderTCCC = (instance: ApiInstance, getMsalToken: () => Promise<string>) => {
//   return instance.client.interceptors.request.use(
//     async instanceConfig => {
//       const token = await getMsalToken()
//       instanceConfig!.headers!.Authorization = `Bearer ${token}`
//       instanceConfig!.headers!['Client'] = 'playground-dev-fe'
//       instanceConfig!.headers!['X-Tenant-Id'] = process.env.REACT_APP_X_TENANT_ID ?? ''
//       return instanceConfig
//     },
//     error => Promise.reject(error),
//   )
// }

// // azAccessToken source changed from useAZToken to acquireTokenSilent
// // tenantId source changed from osContext.tenant.id to env var
// const getInterceptorToEjectExperienceBuilder = (instance: ApiInstance, getMsalToken: () => Promise<string>) => {
//   return instance.client.interceptors.request.use(
//     async instanceConfig => {
//       const token = await getMsalToken()

//       if (token) {
//         instanceConfig!.headers!.Authorization = `Bearer ${token}`
//         instanceConfig!.headers!['Client'] = 'playground-dev-fe'
//       }

//       const tenantId = process.env.REACT_APP_X_TENANT_ID
//       if (tenantId) {
//         instanceConfig!.headers!['X-Tenant-Id'] = tenantId
//       }

//       return instanceConfig
//     },
//     error => Promise.reject(error),
//   )
// }
interface ApiProviderProps extends PropsWithChildren {
  getToken?: () => Promise<string> // ← from root via customProps
}
export const ApiProvider = ({ children, getToken }: ApiProviderProps) => {
  const [isReady, setIsReady] = useState(false)
  const { instance, accounts } = useMsal()

  useEffect(() => {
    if (accounts.length === 0) return

    const account = accounts[0]

    // Shared token getter — acquireTokenSilent handles refresh automatically
    // replaces both osApi.getAccessToken() and useAZToken() entirely
    const getMsalToken = async (): Promise<string> => {
      if (getToken) {
        const token = await getToken()
        return token
      }
      try {
        const response = await instance.acquireTokenSilent({ ...loginRequest, account })
        return response.accessToken
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          window.location.href = `${process.env.REACT_APP_ROOT_URL}/login`
        }
        return ''
      }
    }

    const interceptors = apiInstances.map(apiInstance => {
      return apiInstance.client.interceptors.request.use(
        async config => {
          const token = await getMsalToken()

          if (token) {
            config.headers = {
              ...(config.headers || {}),
              Authorization: `Bearer ${token}`,
              Client: 'playground-dev-fe',
              'X-Tenant-Id': process.env.REACT_APP_X_TENANT_ID ?? '',
            }
          }

          return config
        },
        error => Promise.reject(error),
      )
    })

    setIsReady(true)

    return () => {
      interceptors.forEach((interceptor, index) => {
        apiInstances[index].client.interceptors.request.eject(interceptor)
      })
    }
  }, [instance, accounts, getToken])

  if (!isReady) {
    return null // TODO: Add loading spinner
  }

  return <>{isReady && children}</>
}
